<template>
  <div class="h-full" v-if="upadte">
    <!-- 版本比较 -->
    <el-card
      v-if="pageType === 'compareVersions'"
      class="h-full relative"
      :body-style="{ padding: '0', height: '100%' }"
    >
      <div class="h-full">
        <div class="h-36px border-bottom-1px">
          <span class="text-14px font-bold leading-36px pl-10px">版本比较</span>
          <el-button
            type="default"
            size="mini"
            class="!text-12px absolute top-5px right-10px z-index-100"
            @click="closeDocument"
            >返回</el-button
          >
        </div>
        <el-row :gutter="10" class="h-[calc(100%-36px)]">
          <el-col :span="12" class="h-full relative">
            <div class="file-header">
              <span class="file-name"
                >{{ compareData.version1.code }}_{{ compareData.version1.revision }} [{{
                  compareData.version1.name
                }}]</span
              >
              <img
                src="../../../resource/assets/images/split_screen.png"
                class="cursor-pointer ml-10px"
                @click="toggleFullScreen('version1')"
              />
            </div>
            <div class="w-full h-[calc(100%-44px)] mt-44px">
              <!-- svg/pr格式通过iframe预览 -->
              <iframe
                v-if="['dxf', 'dwg', 'svg'].includes(fileType1)"
                :src="svgUrl1"
                width="100%"
                height="100%"
                class="myiframe"
                allowfullscreen
              ></iframe>
              <iframe
                v-else-if="fileType1 === 'pr'"
                :src="prUrl1"
                width="100%"
                height="100%"
                class="myiframe"
                allowfullscreen
              ></iframe>
              <div v-else class="w-full h-full" id="version1"></div>
            </div>
          </el-col>
          <el-col :span="12" class="h-full relative">
            <div class="file-header">
              <span class="file-name"
                >{{ compareData.version2.code }}_{{ compareData.version2.revision }} [{{
                  compareData.version2.name
                }}]</span
              >
              <img
                src="../../../resource/assets/images/split_screen.png"
                class="cursor-pointer ml-10px"
                @click="toggleFullScreen('version2')"
              />
            </div>
            <!-- svg/pr格式通过iframe预览 -->
            <div class="w-full h-[calc(100%-44px)] mt-44px">
              <iframe
                v-if="fileType2 === 'svg'"
                :src="svgUrl2"
                width="100%"
                height="100%"
                class="myiframe"
                allowfullscreen
              ></iframe>
              <iframe
                v-else-if="fileType2 === 'pr'"
                :src="prUrl2"
                width="100%"
                height="100%"
                class="myiframe"
                allowfullscreen
              ></iframe>
              <div v-else class="w-full h-full" id="version2"></div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <el-row v-else :gutter="10" class="h-full">
      <!-- 查看批注列表面板 -->
      <div
        v-if="showAnnotationListDialog"
        class="annotation-list-panel"
        v-loading="isLoadingAnnotations"
      >
        <div class="annotation-list-header">
          <span class="title">批注列表</span>
          <i class="el-icon-close close-icon" @click="closeAnnotationList"></i>
        </div>
        <div class="annotation-list">
          <el-empty v-if="!annotationLists.length" description="暂无批注记录"></el-empty>
          <div v-else class="annotation-items" :key="updateAnnotationKey">
            <div v-for="(item, index) in annotationLists" :key="index" class="annotation-item">
              <div class="annotation-content">
                <!-- 添加删除按钮 -->
                <div
                  class="delete-annotation-btn"
                  @click.stop="handleDeleteAnnotation(item)"
                  title="删除批注"
                >
                  <i class="el-icon-delete"></i>
                </div>
                <el-image
                  :preview-src-list="
                    item.Annotation ? [`data:image/jpeg;base64,${item.Annotation}`] : []
                  "
                  :src="`data:image/jpeg;base64,${item.Annotation}`"
                  :alt="item.ReviewRecord"
                  class="annotation-image"
                  fit="contain"
                >
                  <template #placeholder>
                    <div class="image-loading">
                      <i class="el-icon-loading"></i>
                      <p>加载中...</p>
                    </div>
                  </template>
                  <template #error>
                    <div class="image-error">
                      <i class="el-icon-picture-outline"></i>
                      <p>图片加载失败</p>
                    </div>
                  </template>
                </el-image>
              </div>
              <div class="annotation-header">
                <span class="annotation-title">{{ item.ReviewRecord }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <image-annotation-new
        v-if="showImageAnnotation"
        :captureProps="captureProps"
        @close="handleAnnotationClose"
      ></image-annotation-new>
      <!-- 只有为svg文件才显示新增编辑按钮 -->
      <div class="absolute top-5px right-60px z-index-100" v-if="mainFileType === 'svg'">
        <el-button type="primary" size="mini" class="!text-12px" @click="handleAnnotation('print')"
          >打印</el-button
        >
        <el-button type="primary" size="mini" class="!text-12px" @click="handleAnnotation"
          >标注</el-button
        >
        <el-button type="primary" size="mini" class="!text-12px" @click="showAnnotationList"
          >查看标注</el-button
        >
        <el-button
          type="primary"
          size="mini"
          class="!text-12px"
          v-if="!isEditTag && !isAddTag && !(splitFileUrl || splitFilePrId)"
          @click="editTag"
          >编辑热点</el-button
        >
        <el-button
          type="primary"
          size="mini"
          class="!text-12px"
          v-if="!isEditTag && !isAddTag && !(splitFileUrl || splitFilePrId)"
          @click="addTag"
          >新增热点</el-button
        >
        <el-button
          type="primary"
          size="mini"
          class="!text-12px"
          v-if="isSaveBtnVisible && !(splitFileUrl || splitFilePrId)"
          @click="saveHotTag"
          >保存</el-button
        >
        <el-button
          type="danger"
          size="mini"
          class="!text-12px"
          v-if="(isSaveBtnVisible || isEditTag) && !(splitFileUrl || splitFilePrId)"
          @click="cancelHotTag"
          >取消</el-button
        >
      </div>
      <el-button
        v-if="!(splitFileUrl || splitFilePrId)"
        type="default"
        size="mini"
        class="!text-12px absolute top-5px right-10px z-index-100"
        @click="closeDocument"
        >返回</el-button
      >
      <el-col :span="spanLeft" class="h-full">
        <cabel-relational
          v-if="cabelMode"
          :loadedModel="loadedModel"
          :modelDocumentId="modelDocumentId"
          @moveCamera="moveCamera"
          @isShowMode="isShowMode"
          @setCableData="setCableData"
          @changePlayerId="changePlayerId"
          @closeCableMode="changeMode('cabel', arguments)"
        ></cabel-relational>
        <process-relational
          ref="processRelational"
          :modelDocumentId="modelDocumentId"
          @changeProcessMode="changeMode('process', arguments)"
          v-if="processMode"
          @changePlayerId="changePlayerId"
          @isShowMode="isShowMode"
          @resetProgress="resetProgress"
          @changeModelColor="changeModelColor"
          @recoverModel="recoverModel"
        ></process-relational>
        <clash-relational
          @moveCamera="moveCamera"
          :modelDocumentId="modelDocumentId"
          @changePlayerId="changePlayerId"
          @setClashData="setClashData"
          @changeClashMode="changeMode('clash', arguments)"
          @isShowMode="isShowMode"
          v-if="clashMode"
        ></clash-relational>
      </el-col>
      <el-col :span="spanRight" class="h-full position-relative">
        <template v-if="!this.$route.query.isOnlyView">
          <el-tooltip v-show="showMode" :content="'展开模式信息'" :open-delay="1000">
            <div
              class="position-absolute p-5px cur_pointer"
              style="top: 50px; z-index: 100; left: 0"
              @click="isShowMode"
            >
              <span
                class="iconfont icon-bg-circleRight text-16px"
                style="background: rgba(0, 0, 0, 0)"
              ></span>
            </div>
          </el-tooltip>
          <el-tooltip v-show="!showDocRelational" :content="'展开关联位号'" :open-delay="1000">
            <div
              class="position-absolute icon-expand-site p-5px cur_pointer"
              @click="showDocRelational = !showDocRelational"
            >
              <div class="b">
                <span
                  class="iconfont icon-bg-circleRight main-color text-24px"
                  style="trans"
                ></span>
              </div>
            </div>
          </el-tooltip>
          <el-tooltip
            v-show="showDocRelational"
            :content="'收缩关联位号' + changeCollapaseZindex"
            placement="top"
            :open-delay="1000"
          >
            <div
              class="position-absolute icon-collapase-site cur_pointer"
              :class="{ 'z-index-999': !changeCollapaseZindex }"
              @click="showDocRelational = !showDocRelational"
            >
              <span class="iconfont icon-bg-circleLeft main-color text-24px"></span>
            </div>
          </el-tooltip>
          <el-tooltip v-show="!showBitRelational" :content="'展开位号基本信息'" :open-delay="1000">
            <div
              class="icon-expand-site-basic position-absolute cur_pointer p-5px"
              @click="showBitRelational = !showBitRelational"
            >
              <div class="b">
                <span class="iconfont icon-bg-circleLeft main-color text-24px"></span>
              </div>
            </div>
          </el-tooltip>
          <el-tooltip
            v-show="showBitRelational"
            content="收缩位号基本信息"
            placement="top"
            :open-delay="1000"
          >
            <div
              class="position-absolute icon-collapase-site icon-collapase-site-basic tl cur_pointer"
              :class="{ 'z-index-999': !changeCollapaseTagZindex }"
              @click="showBitRelational = !showBitRelational"
            >
              <span class="iconfont icon-bg-circleRight main-color text-24px cur_pointer"></span>
            </div>
          </el-tooltip>
          <el-button
            v-if="splitFileUrl || splitFilePrId"
            class="absolute top-7px right-16px z-index-100"
            type="default"
            size="mini"
            @click="closeSplitScreen"
            >关闭分屏</el-button
          >
          <!-- <el-tooltip
            :content="showCloseScreen ? '缩起分屏' : '展开分屏'"
            v-if="splitFileUrl || splitFilePrId"
            placement="top"
            :open-delay="1000"
          >
            <span
              class="iconfont icon-bg-quit split-icon main-color text-16px position-absolute cur_pointer"
              :class="{ 'icon-collapase': !showCloseScreen }"
              :style="showCloseScreen ? '' : 'transform:rotate(180deg)'"
              @click="switchScreen()"
            >收起分屏</span>
          </el-tooltip> -->
        </template>
        <!-- <el-tooltip content="分屏">
          <span
            class="icon-split main-color fz-20 position-absolute cur_pointer"
            :class="{ rotate180: !showBitRelational }"
            @click="splitScreen()"
            >丨</span
          >
        </el-tooltip>-->

        <!-- 预览svg start -->
        <el-dialog
          :visible.sync="showPreviewSvg"
          :title="preViewSvgName"
          width="1200px"
          v-dialogDrag
          id="previewSvgDialog"
        >
          <div
            class="position-absolute modal--svg"
            v-loading="svgPreviewLoading"
            v-if="svgPreviewLoading"
          ></div>
          <iframe
            v-if="showSvgIFrame"
            class="w-full"
            :height="previewHeight"
            @load="loadSvg"
            id="previewSvg"
            :src="`/lib/svgView/index.html?file=${previewSvgUrl}?fileId=${previewSvgFileId}`"
          ></iframe>
        </el-dialog>
        <!-- 预览svg end -->
        <cable-list
          v-show="showCableList && cabelMode"
          ref="cableList"
          @closeTray="closeTray"
          @startDrawLine="startDrawLine"
          @checkMarked="checkMarked"
          @moveCamera="moveCamera"
        ></cable-list>
        <!-- 小地图 -->
        <smallMap v-if="showSmallMap" @changeMap="changeMap" :isOpenMap="isOpenMap"></smallMap>
        <!-- 剖切 -->
        <clip v-if="showClip" :clipData="clipData" @changeClip="changeClip"></clip>
        <!-- 弹框组件 -->
        <component
          :is="showComponents"
          :tagId="tagId"
          :fileId="currentFileId"
          :currentPlayerId="currentPlayerId"
          :loadedModel="loadedModel"
          :currentCode="currentCode"
          :currentModelItem="currentModelItem"
          @changeFileLocation="changeFileLocation"
          @showMarker="showMarker"
          v-if="showDialog"
          ref="componentsRef"
          :setSemitransparent="setSemitransparent"
          @closeComponents="closeComponents"
          @moveCameraByVector="moveCameraByVector"
        ></component>
        <file-view
          :playerOption="wizplayerOption"
          :setSemitransparent="setSemitransparent"
          :isCanAddHot="isCanAddHot"
          @getTagInfo="getModelData"
          @getCableData="getCableData"
          @setProcessStauts="setProcessStauts"
          @changeProcessMode="changeMode('process', arguments)"
          @openCableMode="changeMode('cabel', arguments)"
          @changeClashMode="changeMode('clash', arguments)"
          @changeDocRelational="changeDocRelational"
          @changeMap="changeMap"
          @changeClip="changeClip"
          @changeModeByDialog="changeModeByDialog"
          @loaded="loaded"
          @saveHotTag="saveHotTag"
          ref="fileView"
        ></file-view>
        <doc-relational
          v-show="showDocRelational"
          :setSemitransparent="setSemitransparent"
          @changeIconCollapaseZindex="changeIconCollapaseZindex('doc', arguments)"
          @changePlayerId="changePlayerId"
          @loadPreviewSvg="loadPreviewSvg"
          @changeFile="changeFile"
          @changeMainFile="changeMainFile"
          :documentId="defaultUrlPrams.documentId"
          :fileId="defaultUrlPrams.fileId"
          @getModelData="getModelData"
          @changeCurrentSelectedFileId="changeCurrentSelectedFileId"
          @splitScreen="splitScreen"
          @signleFileId="getSignleFileId"
          ref="docRelational"
          :classId="classId"
          :standardId="standardId"
          :isVersion="isVersion"
          :classCode="classCode"
          :folderId="folderId"
        ></doc-relational>
        <bit-relational
          :setSemitransparent="setSemitransparent"
          :currentFileCode="currentFileCode"
          :currentModel="currentModel"
          @changeIconCollapaseZindex="changeIconCollapaseZindex('tag', arguments)"
          v-show="showBitRelational"
          ref="bitRelational"
          @loadPreviewSvg="loadPreviewSvg"
          @changePlayerId="changePlayerId"
          @changeFile="changeFile"
          @changeTagCode="changeTagCode"
          @splitScreen="splitScreen"
        ></bit-relational>
      </el-col>
    </el-row>
    <!-- 新增活化对象【新增热点】弹框 -->
    <el-dialog
      title="新增热点"
      v-if="isAddActiveVisible"
      :visible.sync="isAddActiveVisible"
      :modal="false"
      :close-on-click-modal="true"
      custom-class="addActiveObj_Dialog"
      width="840px"
      v-dialogDrag
    >
      <el-row :gutter="10">
        <el-col :span="16">
          <el-input v-model="addActiveKeyword" placeholder="输入对象名称" clearable />
        </el-col>
        <el-col :span="4">
          <el-input v-model="activeObj.fontSizeVal" placeholder="字号" clearable />
        </el-col>
        <el-col :span="4" class="pull-right">
          <el-button type="primary" class="iconfont icon-search" @click="searchActitiveObjTable">{{
            `${$t('search')}`
          }}</el-button>
        </el-col>
      </el-row>
      <el-table
        height="320px"
        class="mt-10px"
        :data="activeObjTableData"
        @selection-change="activeObjTableSelectionChange"
        ref="activeObjMultipleTable"
        v-loading="activeObjTableLoading"
        border
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column :label="$t('代码')" prop="code" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('名称')" prop="name" show-overflow-tooltip></el-table-column>
        <el-table-column label="别名" prop="identifier" show-overflow-tooltip> </el-table-column>
        <el-table-column label="是否显示在图面" prop="showSurface">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.showSurface"></el-switch>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-10px"
        @size-change="searchActitiveObjTable"
        @current-change="activeObjTableCurrentChange"
        :current-page.sync="activeObjTablePage.pageNo"
        :page-sizes="$pageSizeAll"
        :page-size.sync="activeObjTablePage.pageSize"
        layout="->, total, sizes, prev, pager, next"
        :total="activeObjTablePage.total"
        background
      ></el-pagination>
      <div slot="footer">
        <el-button size="small" @click="closeAddActiveObjDialog">{{ `${$t('Cancel')}` }}</el-button>
        <el-button type="primary" size="small" @click="saveActiveObj">{{
          `${$t('save')}`
        }}</el-button>
      </div>
    </el-dialog>
    <!-- <div
      v-if="isAddActiveVisible"
      class="activeObj-box"
      :style="{ top: activeObj.top + 80 + 'px', left: activeObj.left - 150 + 'px' }"
    >
      <el-input
        class="w-200px"
        @keyup.enter.native="saveActiveObj"
        v-model="activeObj.code"
        placeholder="请输入内容"
        clearable
      ></el-input>
      <el-select
        class="!w-70px"
        v-model="activeObj.fontSizeVal"
        @change="fontSizeChange"
        filterable
        placeholder="请选择"
      >
        <el-option v-for="item in fontSizeList" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="saveActiveObj">确定</el-button>
    </div> -->

    <!-- 【编辑热点】弹框 -->
    <el-dialog
      title="编辑热点"
      v-if="spotHotEditVisible"
      :visible.sync="spotHotEditVisible"
      :modal="false"
      :close-on-click-modal="true"
      custom-class="addActiveObj_Dialog"
      width="540px"
      v-dialogDrag
    >
      <el-form
        ref="spotHotEditForm"
        :model="spotHotEditForm"
        :rules="spotHotEditFormRules"
        label-width="120px"
      >
        <el-form-item label="当前热点位号">
          <el-input
            v-model="spotHotEditCode"
            :placeholder="`${$t('pleaseSelect')}`"
            class="w-full can-not-input"
            @clear="clearSelectedTag"
            clearable
          >
            <el-button
              slot="append"
              icon="iconfont icon-line-seach"
              @click="tagsDataListDialogVisible = true"
            ></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="当前热点字号" prop="fontSize">
          <el-input v-model="spotHotEditForm.fontSize" placeholder="字号" clearable />
        </el-form-item>
        <el-form-item label="当前热点偏移量" prop="offSetX">
          <el-input v-model="spotHotEditForm.offSetX" placeholder="偏移量" clearable />
        </el-form-item>
        <el-form-item label="当前热点字体" prop="fontFamily">
          <el-select
            class="w-full"
            v-model="spotHotEditForm.fontFamily"
            placeholder="字体"
            clearable
          >
            <el-option
              v-for="(item, index) in svgFontfamilyList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="当前热点颜色" prop="color">
          <el-color-picker v-model="spotHotEditForm.color" color-format="rgb"></el-color-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="closeSpotHotEditDialog">{{ `${$t('Cancel')}` }}</el-button>
        <el-button type="primary" size="small" @click="saveSpotHotEdit">{{
          `${$t('save')}`
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 选择位号弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="tagsDataListDialogVisible"
      title="位号"
      v-dialogDrag
    >
      <tagsListSearch
        v-if="tagsDataListDialogVisible"
        @selectTagId="selectTagId"
        :standardId="standardId"
        :documentFileId="documentFileId"
      />
    </el-dialog>
    <!-- 【编辑热点】弹框旧 -->
    <!-- <div
      class="el-dialog position-fixed absolute w-480px"
      v-show="spotHotEditVisible"
      ref="svgEditDialog"
    >
      <div class="el-dialog__header">
        <span class="el-dialog__title">编辑活化对象</span>
        <button type="button" class="el-dialog__headerbtn" @click="svgEditClose">
          <span class="el-dialog__close el-icon el-icon-close"></span>
        </button>
      </div>
      <div class="el-dialog__body">
        <el-table height="240px" border :data="svgTableData" class="noSelect">
          <el-table-column label="识别内容" prop="originContent"></el-table-column>
          <el-table-column label="替换内容">
            <template slot-scope="scope">
              <div
                :contenteditable="true"
                class="edit-style"
                @blur="svgEditBlur($event, scope.row)"
                v-text="scope.row.newContent"
              ></div>
            </template>
          </el-table-column>
        </el-table>
        <p class="text-12px text-[#868383] pt-10px">连续点击识别文字，加入列表替换。</p>
        <div class="text-center mt-10px">
          <el-button type="primary" :loading="svgEditLoading" @click="editSvgCode">确定</el-button>
          <el-button @click="svgEditClose">取消</el-button>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import TagService from '@/services/tags'
import ApiMixinTagObjectBrowse from '@/assets/js/api/tagObjectBrowse'
import DocumentService from '@/services/DocumentService'
import qs from 'qs'
import html2canvas from 'html2canvas'
// 文件预览
import fileView from './components/fileView'
// 文档相关
import docRelational from './components/docRelational'
// 位号相关
import bitRelational from './components/bitRelational'
// 电缆相关
import cabelRelational from './components/cabelRelational'
// 进度相关
import processRelational from './components/processRelational'
// 碰撞相关
import clashRelational from './components/clashRelational'
// 电缆列表
import cableList from './components/cableList'
// 小地图
import smallMap from './components/smallMap'
// 位号搜索组件
import tagsListSearch from './components/tagsListSearch'
// 批注组件
import ImageAnnotationNew from '../../components/imageAnnotationNew'

const clip = () => {
  return import('./components/clip')
}
// 预设漫游路径
const roamPathList = () => {
  return import('./components/roamPathList')
}
// 测点历史数据
const measurePoint = () => {
  return import('./components/measurePoint')
}
// 关联测点信息
const bindMeasurePoint = () => {
  return import('./components/bindMeasurePoint')
}
// 组态管理目录树
const configureManage = () => {
  return import('./components/configureTree')
}
// 摄像头列表
const monitorList = () => {
  return import('./components/monitorList')
}
// 人员定位列表
const personnelPositioning = () => {
  return import('./components/personnelPositioning')
}
// 电子围栏列表
const fenceDataList = () => {
  return import('./components/fenceDataList')
}
const markList = () => {
  return import('./components/markerList')
}
// 材质编辑
const editTexture = () => {
  return import('./components/editTexture')
}
// 模型透明度
const transparencySetting = () => {
  return import('./components/transparencySetting')
}
// 设备信息
const equipmentInfo = () => {
  return import('./components/equipment/equipmentInfo')
}
// 报警信息
const AlarmInfo = () => {
  return import('./components/alarm/AlarmInfo')
}
export default {
  name: 'docView',
  mixins: [ApiMixinTagObjectBrowse],
  components: {
    ImageAnnotationNew,
    fileView,
    docRelational,
    bitRelational,
    cabelRelational,
    processRelational,
    clashRelational,
    cableList,
    smallMap,
    roamPathList,
    personnelPositioning,
    fenceDataList,
    measurePoint,
    bindMeasurePoint,
    configureManage,
    monitorList,
    clip,
    markList,
    editTexture,
    transparencySetting,
    equipmentInfo,
    AlarmInfo,
    tagsListSearch,
  },
  inject: ['reload'],
  data() {
    return {
      updateAnnotationKey: 1,
      showAnnotationListDialog: false,
      showImageAnnotation: false,
      captureProps: {
        imgUrl: '',
      },
      mainFileType: '', // 主页文件类型
      isSaveBtnVisible: false, // 是否显示保存按钮
      isAddTag: false, // 是否新增标签
      isEditTag: false, // 是否编辑标签
      activeObj: {
        // 当编辑或者新增的活化数据参数
        top: 0,
        left: 0,
        code: 'text',
        fontSizeVal: '12',
      },
      fontSizeList: ['6', '8', '10', '12', '14', '16', '18', '20', '22'], // 活化新增测点字体大小集合
      isAddActiveVisible: false, // 是否显示新增/编辑活化框
      temporaryVal: '', // 储存当活化框临时的修改项对应的唯一标示
      svgHotTagInfos: [], // 传递给后端的活化测点集合
      isCanAddHot: false, // 是否能添加活化热点
      mainFlag: '', // 主页的移交状态
      loadedModel: false,
      showClip: '', // 是否显示剖切配置弹框
      clipData: '', // 剖切对象数据
      svgPreviewLoading: false,
      changeCollapaseZindex: true, // 改变收缩关联位号图标z-index
      changeCollapaseTagZindex: true, // 改变收缩基本位号图标z-index
      showComponents: markList, // 弹框当前显示的组件
      showDialog: false, // 是否显示弹框
      previewSvgUrl: '', // 预览的svg地址
      previewSvgFileId: '',
      spotHotEditVisible: false,
      svgTableData: [],
      svgParams: {},
      upadte: true, // 判断是否重新刷新
      objectCode: '',
      defaultSvgCode: '',
      showMode: false,
      processMode: false,
      cabelMode: false,
      clashMode: false,
      showCableList: false, // 是否显示电缆列表
      showSmallMap: false, // 是否展开小地图
      isOpenMap: false, // 是否默认开启地图全景
      currentCode: '',
      currentModelItem: 0,
      preViewSvgName: '', // 预览svg
      previewVersionTag: '',
      splitFileUrl: '', // 分屏的文件路径
      splitFilePrId: '', // pr分屏文件
      previewSvgLoading: false,
      showPreviewSvg: false,
      showBitRelational: false,
      showDocRelational: false,
      showCloseScreen: false,
      // 默认的浏览器地址栏参数
      defaultUrlPrams: {
        documentId: '', // 默认加载的文档id
        fileId: '', // 默认加载的文件id
      },
      currentSelectedFileId: '',
      playerServer: '', // player服务地址
      playerServerProtocol: '', // player服务协议
      playerBtnVisible: null, // player工具栏按钮显示状态
      wizplayerOption: null, // wizplayer配置可选项
      player: null,
      pixelCullingThres: null,
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
      spanRight: 24,
      spanLeft: 0,
      tagId: '', // 关联测点的tagId
      modelDocumentId: '', // 模型文件id
      currentPlayerId: '', // 模型md5
      setSemitransparent: false, // 弹框是否设置为半透明
      showSvgIFrame: false,
      currentFileCode: '', // 当前点击的文档对象的编码
      getSvgCodeDataFlag: false, // 点击svg时如果查询不到数据则反向查询
      currentWindow: '', // 当前路由
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      lastCode: null,
      tableHeader: [],
      currentModel: {},
      svgEditLoading: false,
      addActiveKeyword: '',
      addActivefontSize: '',
      activeObjTableData: [],
      activeObjTableLoading: false,
      activeObjSelections: [],
      activeObjTablePage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      spotHotEditForm: {
        id: '',
        tagId: '',
        code: '',
        fontFamily: '',
        fontSize: '',
        offSetX: '',
        color: '',
        transform: '',
      },
      spotHotEditFormRules: {
        fontSize: [{ required: true, message: '请选择当前热点字号', trigger: 'change' }],
        offSetX: [{ required: true, message: '请填写当前热点偏移量', trigger: 'blur' }],
        fontFamily: [{ required: true, message: '请设置当前热点字体', trigger: 'blur' }],
        color: [{ required: true, message: '请选择设置热点颜色', trigger: 'blur' }],
      },
      spotHotEditTagSelected: null,
      documentFileId: '',
      svgFontfamilyList: [
        'Arial',
        'Helvetica',
        'Times New Roman',
        'Verdana',
        'Courier New',
        'Georgia',
        'serif',
        'sans-serif',
        'monospace',
      ],
      tagsDataListDialogVisible: false,
      spotHotEditCode: '',
      fileType1: '',
      fileType2: '',
      svgUrl1: '',
      svgUrl2: '',
      prUrl1: '',
      prUrl2: '',
      annotationImgUrl: '', // 标注图片url
    }
  },
  computed: {
    basePath() {
      const routerBase = _.get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (!routerBase) {
        return ''
        // eslint-disable-next-line no-else-return
      } else if (routerBase && Array.isArray(routerBase)) {
        return routerBase.length ? `/${routerBase[0]}` : ''
      }
      return `${window.location.origin}/#/${routerBase}`
    },
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    progressLocation() {
      // 施工进度默认视角
      const location = _.find(this.systemParams, { parameterCode: 'PLAYER_PROGRESS_LOCATION' })
      return location ? location.parameterValue : null
    },
    versionManagement() {
      const version = _.find(this.systemParams, { parameterCode: 'versionManagement' }) || {}
      return version.parameterValue
    },
    previewHeight() {
      return `${document.body.offsetHeight - 200}px`
    },
    currentFileId() {
      return this.$refs.fileView.currentFileId
    },
    DisplayNoDataAttribute() {
      const DisplayNoDataAttribute =
        _.find(this.systemParams, { parameterCode: 'DisplayNoDataAttribute' }) || {}
      return DisplayNoDataAttribute.parameterValue || 'true'
    },
    documentId() {
      return this.$route.query.documentId
    },
    classId() {
      return this.$route.query.classId
    },
    standardId() {
      return this.$route.query.standardId
    },
    isVersion() {
      return this.$route.query.isVersion
    },
    classCode() {
      return this.$route.query.classCode || ''
    },
    folderId() {
      return this.$route.query.folderId || ''
    },
    pageType() {
      return this.$route.query.pageType || ''
    },
    compareData() {
      return JSON.parse(this.$route.query.compareData) || {}
    },
    // 文件服务地址
    standardServer() {
      return Wiz.GetModuleConfig('legacy-resource')?.currentEnv?.VUE_APP_STANDARD_SERVER
    },
    // 文件预览服务地址
    filePreviewServer() {
      return Wiz.globalSettings.dynamicModules.modules['legacy-resource']?.config?.currentEnv
        ?.VUE_APP_FILE_PREVIEW_SERVER
    },
  },
  watch: {
    async spotHotEditVisible(val) {
      if (val) {
        // 先重置表单数据
        this.spotHotEditForm = this.$options.data().spotHotEditForm
        this.spotHotEditCode = ''
        // 查询对应tagId的位号数据
        this.activeObjTablePage.pageNo = 1
        await this.getActitiveObjTableData(this.svgParams.tagId)
        // 添加必填项
        Object.keys(this.spotHotEditFormRules).forEach((key) => {
          this.spotHotEditFormRules[key][0].required = true
        })
        // 判断是否为原文本
        const originTexts =
          this.activeObjTableData.filter((item) => {
            return item.code === this.svgParams.code
          }) || []
        // 当前热点对应的数据的code值
        this.spotHotEditCode =
          this.activeObjTableData.filter((item) => {
            return item.id === this.svgParams.tagId
          })[0]?.code || ''
        const textAttributes = this.svgParams.textAttributes
        this.spotHotEditForm = {
          id: textAttributes.id,
          tagId: textAttributes.tagid,
          fontFamily: textAttributes['font-family'],
          fontSize: textAttributes['font-size'].replace('px', ''),
          offSetX: textAttributes.dx || '0',
          color: 'rgb(0, 107, 255)',
          transform: textAttributes.transform,
          isOriginText: !originTexts.length,
        }
      }
    },
    processMode(val) {
      if (val) {
        // 当为进度模拟且模型加载完时，移动相机到固定位置
        if (this.$refs.fileView.loadModel) {
          this.$nextTick(() => {
            this.$refs.processRelational.canSelect = true
          })
          this.$refs.fileView.moveCameraByVector(this.progressLocation)
        }
        this.$refs.fileView.leftCom = 'process'
      }
    },
    $route(route) {
      if (route.name === 'docView') {
        const defaultParams = this.$route.params
        /**
         * 工作台点击进来，查看标记
         */
        if (defaultParams.type === 'showMark') {
          // 切换标记状态为显示， 模型与文档定位
          this.showAndLocationMark(defaultParams)
        }
      }
    },
  },
  methods: {
    closeAnnotationList() {
      this.showAnnotationListDialog = false
      this.annotationLists = []
    },
    handleDeleteAnnotation(item) {
      if (!item || !item.Id) {
        this.$message.error('无效的批注数据')
        return
      }

      this.$confirm('确认删除该批注？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // 显示加载状态
          const loading = this.$loading({
            lock: true,
            text: '正在删除...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          })

          // 调用删除API
          return new Promise((resolve, reject) => {
            window.top.V8.DelDiyTableRow(
              {
                TableName: 'diy_annotations_list',
                Id: item.Id,
              },
              (result) => {
                if (result.Code === 1) {
                  resolve(result)
                } else {
                  reject(new Error(result.Msg || '删除失败'))
                }
              }
            )
          })
            .then(async () => {
              // 删除成功后重新获取最新数据
              this.annotationLists = this.annotationLists.filter((annotation) => {
                return annotation.Id !== item.Id
              })
              this.updateAnnotationKey += 1

              loading.close()
              this.$message.success('删除成功')

              // 如果删除后列表为空，关闭面板
              if (this.annotationLists.length === 0) {
                this.showAnnotationListDialog = false
              }
            })
            .catch((error) => {
              loading.close()
              this.$message.error(error.message || '删除失败')
              console.error('删除批注失败:', error)
            })
        })
        .catch(() => {
          // 用户取消删除，不做任何操作
        })
    },
    getUrlParam(url, name) {
      const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`) // 构造一个含有目标参数的正则表达式对象
      const r = url.match(reg) // 匹配目标参数
      if (r != null) return unescape(r[2])
      return null // 返回参数值
    },
    async getAnnotationLists() {
      this.isLoadingAnnotations = true
      const self = this
      try {
        const currentStandardId = this.getUrlParam(
          decodeURIComponent(window.top.location.href),
          'standardId'
        )
        const fileName = localStorage.getItem('currentViewFileTitle')

        const res = await window.top.V8.FormEngine.GetTableData({
          FormEngineKey: 'diy_annotations_list',
          _Where: [
            {
              Name: 'FileName',
              Value: fileName,
              Type: 'Like',
            },
            {
              Name: 'DataStandard',
              Value: currentStandardId,
              Type: '=',
            },
          ],
          _PageSize: 999,
          _PageIndex: 1,
        })
        console.log(res, 'res-1122')
        if (res.Code === 1 && res.Data && res.Data.length > 0) {
          self.annotationLists = res.Data
          return true
        }
        return false
      } catch (error) {
        console.error('获取批注列表失败:', error)
        this.$message.error('获取批注列表失败')
        return false
      } finally {
        this.isLoadingAnnotations = false
      }
    },
    async showAnnotationList() {
      // 显示加载状态
      const loading = this.$loading({
        lock: true,
        text: '加载批注列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      try {
        const hasData = await this.getAnnotationLists()
        if (hasData) {
          this.showAnnotationListDialog = true
        } else {
          this.$message.info('暂无批注记录')
        }
      } catch (error) {
        console.error('加载批注列表失败:', error)
        this.$message.error('加载批注列表失败')
      } finally {
        loading.close()
      }
    },
    // 新增热点
    addTag() {
      this.isSaveBtnVisible = true
      this.isAddTag = true
      this.isEditTag = false
      // this.isAddActiveVisible = true
    },
    // 编辑热点
    editTag() {
      this.isSaveBtnVisible = false
      this.isAddTag = false
      this.isEditTag = true
    },
    // 取消
    cancelHotTag() {
      this.isSaveBtnVisible = false
      this.isAddTag = false
      this.isEditTag = false
    },
    // 搜索热点表格
    searchActitiveObjTable() {
      this.activeObjTablePage.pageNo = 1
      this.getActitiveObjTableData()
    },
    // 新增热点获取表格数据
    async getActitiveObjTableData(tagId) {
      const params = {
        standardId: this.standardId,
        documentFileId: this.documentFileId,
        keyword: this.addActiveKeyword,
        sorting: 'code asc',
        skipCount: this.activeObjTablePage.pageNo,
        maxResultCount: this.activeObjTablePage.pageSize,
      }
      if (tagId) {
        params.tagId = tagId
      }
      const res = await DocumentService.getTagsList(params)
      if (res && res.code === 0) {
        this.activeObjTableData = res.data.map((item) => {
          item.showSurface = true
          return item
        })
        this.activeObjTablePage.total = res.totalCount
      }
    },
    // 新增热点表格勾选
    activeObjTableSelectionChange(val) {
      if (val.length > 1) {
        this.$refs.activeObjMultipleTable.clearSelection()
        this.$refs.activeObjMultipleTable.toggleRowSelection(val[val.length - 1])
      } else {
        this.activeObjSelections = val
      }
    },
    // 新增热点表格分页
    activeObjTableCurrentChange(val) {
      this.activeObjTablePage.pageNo = val
      this.getActitiveObjTableData()
    },
    // 关闭新增热点弹框
    closeAddActiveObjDialog() {
      this.isAddActiveVisible = false
    },
    // 编辑热点保存
    saveSpotHotEdit() {
      // console.log(this.spotHotEditForm, 'this.spotHotEditForm')
      this.$refs.spotHotEditForm.validate(async (valid) => {
        if (valid) {
          if (!this.spotHotEditForm.tagId) {
            this.$confirm('将删除此热点, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(async () => {
              this.saveEdit()
            })
          } else {
            this.saveEdit()
          }
        }
      })
    },
    async saveEdit() {
      const iframeDocument = document
        .getElementsByTagName('iframe')[0]
        .contentDocument.getElementsByTagName('iframe')[0].contentDocument
      const res = await DocumentService.editSvgFileContent({
        fileId: this.$refs.fileView.mainFileId,
        svgHotTagInfos: [{ ...this.spotHotEditForm }],
      })
      if (res && res.code === 0) {
        this.$message.success('保存成功')
        this.spotHotEditVisible = false
        // 刷新页面
        iframeDocument.location.reload(true)
        this.svgHotTagInfos = []
        window.svgData[window.location.href].svgHotTrigger(
          this.spotHotEditForm.code,
          this.spotHotEditForm.tagId
        )
        // const url = `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${this.$refs.fileView.mainFileId}`
        // this.$refs.fileView.mainResourceUrl = ''
        // this.$refs.fileView.mainResourceUrl = url
        // this.loadPreviewSvg({
        //   fileName: this.preViewSvgName,
        //   versionTag: this.previewVersionTag,
        //   url,
        //   fileId: this.svgParams.fileId,
        // })
      }
    },
    // 编辑热点时清除位号
    clearSelectedTag() {
      this.spotHotEditForm.tagId = ''
      this.spotHotEditForm.code = ''
      // 删除必填
      Object.keys(this.spotHotEditFormRules).forEach((key) => {
        this.spotHotEditFormRules[key][0].required = false
      })
    },
    selectTagId(val) {
      this.spotHotEditForm.tagId = val.id
      if (!this.spotHotEditForm.isOriginText) {
        this.spotHotEditForm.code = val.code
      } else {
        this.spotHotEditForm.code = this.svgParams.code
      }
      this.spotHotEditCode = val.code
      this.tagsDataListDialogVisible = false
    },
    // 关闭编辑热点弹框
    closeSpotHotEditDialog() {
      this.spotHotEditVisible = false
    },
    // 关闭编辑热点弹框【旧】
    svgEditClose() {
      this.spotHotEditVisible = false
      this.isSaveBtnVisible = false
      this.isAddTag = false
      this.isEditTag = false
    },
    // 活化字体大小改变事件
    fontSizeChange(val) {
      this.activeObj.fontSizeVal = val
    },
    // 新增热点保存
    saveActiveObj() {
      // 新增热点保存为临时热点未选择数据
      if (!this.activeObjSelections.length && !this.temporaryVal) {
        this.$message.error('请勾选数据')
        return
      }
      // 修改临时热点未勾选数据
      if (!this.activeObjSelections.length && this.temporaryVal) {
        this.$message.warning('清除此热点')
      }
      this.isAddActiveVisible = false

      if (!this.activeObj.isOriginText) {
        this.activeObj.code = this.activeObjSelections[0]?.code || ''
      }
      if (this.activeObj.isOriginText && !this.activeObjSelections.length) {
        this.activeObj.code = ''
      }
      this.activeObj.selections = this.activeObjSelections[0] || []
      // enter时修改或者编辑的操作。根据是否存在临时修改的code值来判断
      if (this.temporaryVal) {
        this.changeActiveObj()
      } else if (this.activeObj.code.trim()) {
        this.addActiveObj()
      }
    },
    // 新增为临时热点
    addActiveObj() {
      // 这里有三种情况： 1.在空白处点新增 2.在已有文本上点新增显示在图面 3.在已有文本上新增不显示在图面
      // console.log(this.svgParams, 'this.svgParams')
      if (this.svgParams.code) {
        // 在已有文本上新增
        this.activeObj.code = this.svgParams.code // 用原本识别的code
        this.activeObj.color = this.svgParams.fill
        this.activeObj.fontFamily = this.svgParams.textAttributes['font-family']
        this.activeObj.isOriginText = true
      } else {
        this.activeObj.isOriginText = false
      }
      const transformVal =
        this.svgParams.textAttributes?.transform ||
        `matrix(1 0 0 1.4 ${this.activeObj.realLocation.x} ${this.activeObj.realLocation.y})`
      const iframeDocument = document
        .getElementsByTagName('iframe')[0]
        .contentDocument.getElementsByTagName('iframe')[0].contentDocument
      const svgDom = iframeDocument.getElementsByTagName('svg')[0]
      // 移除光标
      this.removeMarker(svgDom)
      const g = svgDom.ownerDocument.createElementNS('http://www.w3.org/2000/svg', 'g')
      // 设置临时项的唯一标示用来区分新增和编辑，已经当code一样时的查询
      const temporaryText = this.$refs.fileView.generateUUID()
      g.setAttribute('temporaryText', temporaryText)
      g.innerHTML = `<a style="cursor: pointer; fill: rgb(255, 0, 0);">
          <text transform="${transformVal}" font-family="${this.activeObj.fontFamily}" font-size="${this.activeObj.fontSizeVal}">${this.activeObj.code}</text>
        </a>`
      svgDom.appendChild(g)
      this.svgHotTagInfos.push({
        code: this.activeObj.code,
        locateX: String(this.activeObj.realLocation.x),
        locateY: String(this.activeObj.realLocation.y),
        fontSize: this.activeObj.fontSizeVal,
        showSurface: this.activeObj.selections.showSurface,
        color: this.activeObj.color || 'rgb(0, 107, 255)',
        fontFamily: this.activeObj.fontFamily || 'Arial',
        transform: transformVal,
        tagId: this.activeObj.selections.id,
        id: temporaryText,
        isOriginText: this.activeObj.isOriginText,
      })
    },
    // 修改临时热点
    changeActiveObj() {
      // 获取g标签集合
      const iframeDocument = document
        .getElementsByTagName('iframe')[0]
        .contentDocument.getElementsByTagName('iframe')[0].contentDocument
      const svgDomChildrens = iframeDocument.getElementsByTagName('svg')[0].children
      let curDom = null
      for (let i = 0; i < svgDomChildrens.length; i += 1) {
        curDom = svgDomChildrens[i]
        // 循环遍历节点，获取到当前编辑的那个节点对象
        if (
          curDom.nodeName === 'g' &&
          curDom.attributes[0]?.nodeName === 'temporaryText' &&
          curDom.attributes[0]?.nodeValue === this.temporaryVal
        ) {
          // 查找当前修改热点的索引
          // eslint-disable-next-line no-loop-func
          const index = _.findIndex(this.svgHotTagInfos, (val) => {
            return val.id === curDom.getAttribute('temporaryText')
          })
          if (this.activeObj.code.trim()) {
            const transformVal = this.activeObj.transform
            this.svgHotTagInfos.splice(index, 1, {
              code: this.activeObj.code,
              locateX: String(this.activeObj.realLocation.x),
              locateY: String(this.activeObj.realLocation.y),
              fontSize: this.activeObj.fontSizeVal,
              showSurface: this.activeObj.selections.showSurface,
              color: this.activeObj.color || 'rgb(0, 107, 255)',
              fontFamily: this.activeObj.fontFamily || 'Arial',
              transform: transformVal,
              tagId: this.activeObj.selections.id,
              id: this.activeObj.id,
              isOriginText: this.activeObj.isOriginText,
            })
            // 有值时编辑
            curDom.innerHTML = `<a style="cursor: pointer; fill: rgb(255, 0, 0);">
                <text transform="${transformVal}" font-family="${this.activeObj.fontFamily}" font-size="${this.activeObj.fontSizeVal}">${this.activeObj.code}</text>
              </a>`
          } else {
            this.svgHotTagInfos.splice(index, 1)
            // 无值时临时删除
            curDom.remove()
          }
        }
      }
    },
    // 移除光标的方法
    removeMarker(svgDom) {
      const svgDomChildrens = svgDom.children
      let curDom = null
      for (let i = 0; i < svgDomChildrens.length; i += 1) {
        curDom = svgDomChildrens[i]
        // 循环遍历节点，获取到当前编辑的那个节点对象
        if (
          curDom.nodeName === 'g' &&
          curDom.attributes[0]?.nodeName &&
          curDom.attributes[0]?.nodeName === 'isMarker'
        ) {
          curDom.remove()
        }
      }
    },
    getSignleFileId(val) {
      this.documentFileId = val
    },
    // 向svg中植入光标操作
    insertMarker() {
      const iframeDocument = document
        .getElementsByTagName('iframe')[0]
        .contentDocument.getElementsByTagName('iframe')[0].contentDocument
      const svgDom = iframeDocument.getElementsByTagName('svg')[0]
      // 移除光标
      this.removeMarker(svgDom)
      // 重新创建光标
      const g = svgDom.ownerDocument.createElementNS('http://www.w3.org/2000/svg', 'g')
      // 设置光标的区分
      g.setAttribute('isMarker', true)
      g.innerHTML = `<text transform="matrix(1 0 0 1.4 ${this.activeObj.realLocation.x} ${this.activeObj.realLocation.y})" fill="rgb(255,58,48)" font-size="2">|</text>`
      svgDom.appendChild(g)
    },
    // 保存热点方法
    async saveHotTag() {
      const iframeDocument = document
        .getElementsByTagName('iframe')[0]
        .contentDocument.getElementsByTagName('iframe')[0].contentDocument
      const svgDom = iframeDocument.getElementsByTagName('svg')[0]
      // 移除光标
      this.removeMarker(svgDom)
      if (!this.svgHotTagInfos.length) {
        this.$message.warning('热点不能为空！')
        return
      }
      this.$refs.fileView.mainFileLoading = true
      const res = await DocumentService.addSvgHotTags({
        svgHotTagInfos: this.svgHotTagInfos,
        fileId: this.$refs.fileView.mainFileId,
        documentFileId: this.documentFileId,
        // siteId: this.currentProject.id,
      })
      this.$refs.fileView.mainFileLoading = false
      if (res && res.code === 0) {
        this.$message({
          type: 'success',
          message: '热点新增成功',
          duration: 500,
          onClose: () => {
            // 刷新页面
            // let iframeDom = document.getElementById('mainSvgIframe')
            // iframeDom.src = `/lib/svgView/index.html?file=${res.data.md5}?fileId=${this.$refs.fileView.mainFileId}`
            // this.$refs.fileView.mainResourceUrl = `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${res.data.md5}`
            iframeDocument.location.reload(true)
            this.svgHotTagInfos = []
            // 关闭弹框
            this.isAddActiveVisible = false
            this.isSaveBtnVisible = false
            this.isAddTag = false
            this.isEditTag = false
          },
        })
      } else {
        this.$message.error(res.msg)
      }
    },
    showAndLocationMark(defaultParams) {
      this.$nextTick(() => {
        this.showMarker(defaultParams.detail)
        // 模型or文件定位
        const Location = defaultParams.detail.cameraPosition
        if (!_.isNil(Location)) {
          if (defaultParams.detail.markType === '2') {
            this.$refs.fileView.modelLocationByComponent = Location
          } else if (defaultParams.detail.markType === '1') {
            const info = JSON.parse(Location)
            this.$refs.fileView.fileLocationByComponent = `page=${info.page}&zoom=auto`
          }
        }
      })
    },
    changeIconCollapaseZindex(type, bol) {
      if (type === 'doc') {
        this.changeCollapaseZindex = bol[0]
      } else {
        this.changeCollapaseTagZindex = bol[0]
        this.changeCollapaseZindex = bol[0]
      }
    },
    svgEditBlur(e, row) {
      row.newContent = e.target.innerText
    },
    // svg编辑
    async editSvgCode() {
      const isEmpty = _.find(this.svgTableData, (item) => {
        return item.newContent === ''
      })
      if (isEmpty) {
        this.$message.warning('为空将删除热点！')
      }
      const notValid = _.find(this.svgTableData, (item) => {
        return item.newContent.indexOf('<') > -1 || item.newContent.indexOf('>') > -1
      })
      if (notValid) {
        this.$message.warning('存在非法字符"".""')
        return
      }
      const iframeDocument = document
        .getElementsByTagName('iframe')[0]
        .contentDocument.getElementsByTagName('iframe')[0].contentDocument
      this.svgEditLoading = true
      const res = await DocumentService.updateSvg(this.$refs.fileView.mainFileId, this.svgTableData)
      // {
      // id: this.svgParams.fileId,
      // svgFileModels: this.svgTableData,
      // }
      if (res && res.code === 0) {
        this.$message.success('编辑成功!')
        this.$refs.docRelational.findTagClassAssociation()
        // 刷新页面
        iframeDocument.location.reload(true)
        this.svgHotTagInfos = []
        // 关闭弹框
        this.svgEditClose()
        // const url = `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${res.data.md5}`
        // if (this.svgParams.frame === 'mainSvgIframe') {
        //   this.$refs.fileView.mainResourceUrl = ''
        //   this.$refs.fileView.mainResourceUrl = url
        // } else if (this.svgParams.frame === 'svgIframe') {
        //   this.$refs.fileView.drawUrl = ''
        //   this.$refs.fileView.drawUrl = url
        // } else if (this.svgParams.frame === 'previewSvg') {
        //   this.loadPreviewSvg({
        //     fileName: this.preViewSvgName,
        //     versionTag: this.previewVersionTag,
        //     url,
        //     fileId: this.svgParams.fileId,
        //   })
        // }
        // const url = `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${this.$refs.fileView.mainFileId}`
        // this.loadPreviewSvg({
        //   fileName: this.preViewSvgName,
        //   versionTag: this.previewVersionTag,
        //   url,
        //   fileId: this.$refs.fileView.mainFileId,
        // })
      } else {
        this.$message.error(res.message)
      }
      this.svgEditLoading = false
    },
    // svgEditClose() {
    //   // 解决偶现的关闭弹窗遮罩层不关闭问题
    //   const svgEditDialog = this.$refs.svgEditDialog.$el
    //   this.$nextTick(() => {
    //     const modals = svgEditDialog.parentNode.getElementsByClassName('v-modal')
    //     if (modals.length) {
    //       svgEditDialog.parentNode.removeChild(modals[0])
    //     }
    //   })
    // },
    // 点击分屏切换关联位号信息
    changeDocRelational(id) {
      this.defaultUrlPrams.documentId = id
    },
    // 还原模型
    recoverModel() {
      this.$refs.fileView.recoverModel()
    },
    checkMarked() {
      this.$refs.fileView.checkMarked()
    },
    startDrawLine(val) {
      this.$refs.fileView.startDrawLine(val)
    },
    // 重置进度条
    resetProgress() {
      this.$refs.fileView.resetProgress()
    },
    changeModelColor(val) {
      this.$refs.fileView.highlightData = val
    },
    moveCamera(val) {
      this.$nextTick(() => {
        if (this.clashMode) {
          // 碰撞模块点击需要设置模型高亮
          this.$refs.fileView.leftCom = 'clash'
          this.$refs.fileView.moveCameraByCode(val)
        } else {
          this.$refs.fileView.leftCom = ''
          this.$refs.fileView.moveCameraByCode(val)
        }
      })
    },
    moveCameraByVector(val) {
      this.$refs.fileView.moveCameraByVector(val)
    },
    // 影藏或者打开小地图
    changeMap(val, type) {
      // 第一次从模型那边过来，不打开弹框，但是打开地图
      if (type !== 'model') {
        this.showSmallMap = val
      }
      if (val) {
        this.isOpenMap = val
      }
    },
    changeClip(val, clipData = {}) {
      this.showClip = val
      this.clipData = clipData
    },
    // 隐藏或打开面板
    isShowMode(val) {
      if (!this.showMode) {
        this.showMode = true
        this.spanLeft = 0
        this.spanRight = 24
      } else {
        this.showMode = false
        this.spanLeft = 7
        this.spanRight = 17
      }
    },
    // 切换电缆模式
    changeMode(type, val) {
      if (val[0]) {
        this.spanLeft = 7
        this.spanRight = 17
      } else {
        this.spanLeft = 0
        this.spanRight = 24
        // 取消模型中tool栏选中状态
        this.$refs.fileView.activePlayerTabName = ''
        // 去除面板
        this.$refs.fileView.leftCom = ''
        this.$refs.fileView.showTab = true
        this.$refs.fileView.checkMarked()
      }
      switch (type) {
        case 'process':
          this.processMode = val[0]
          this.cabelMode = false
          this.clashMode = false
          break
        case 'cabel':
          this.cabelMode = val[0]
          this.processMode = false
          this.clashMode = false
          break
        case 'clash':
          this.clashMode = val[0]
          this.processMode = false
          this.cabelMode = false
          break
        default:
          this.clashMode = false
          this.processMode = false
          this.cabelMode = false
          break
      }
    },
    // 关闭弹框
    closeComponents() {
      this.showDialog = false
      this.$refs.fileView.initModelVisible()
      this.showComponents = ''
    },
    // 切换弹框的显示与隐藏
    changeModeByDialog(val) {
      const activeDialog = val.split('.')[1]
      if (this.showComponents === activeDialog) {
        this.closeComponents()
      } else {
        this.showComponents = activeDialog
        this.showDialog = true
      }
    },
    getCableData(data) {
      this.$refs.cableList.trayCode = data.code
      // this.trayCode = data.code
      this.showCableList = true
    },
    loaded(val) {
      this.loadedModel = val
      if (this.processMode) {
        this.$refs.processRelational.loaded = val
      }
    },
    // 关闭桥架卡片
    closeTray() {
      this.showCableList = false
    },
    setProcessStauts(val) {
      this.$refs.processRelational.canSelect = true
    },
    // 设置电缆信息
    setCableData(data) {
      this.$nextTick(() => {
        this.$refs.fileView.cableInfo = JSON.stringify(data)
        // 绘制面板
        this.$refs.fileView.startDrawPanel(JSON.stringify(data))
        // 电缆描线
        this.$refs.fileView.startDrawLine(JSON.stringify(data))
      })
    },
    setClashData(data) {
      this.$nextTick(() => {
        this.$refs.fileView.clashInfo = JSON.stringify(data)
        this.$refs.fileView.startDrawPoint(JSON.stringify(data))
      })
    },
    loadPreviewSvg($onData) {
      this.showSvgIFrame = false
      this.$nextTick(() => {
        this.showSvgIFrame = true
        this.showPreviewSvg = true
        this.previewSvgLoading = true
        this.preViewSvgName = $onData.fileName
        this.previewVersionTag = $onData.versionTag
        this.previewSvgUrl = $onData.url
        this.previewSvgFileId = $onData.fileId
        this.svgPreviewLoading = true
      })
    },
    loadSvg() {
      // 加载完svg
      this.svgPreviewLoading = false
    },
    // 文档关联树结构分屏
    async splitScreen(data) {
      const fileType = _.split(data.fileName, '.')[1]
      // if (
      //   this.$refs.fileView.mainFileType === `${fileType}` &&
      //   this.currentEnv.VUE_APP_CURRENT_PROJECT !== 'GZ'
      // ) {
      //   this.$message({
      //     message: '同类型不能进行分屏！',
      //     type: 'warning',
      //   })
      //   return
      // }
      // 对比主页的文件类型和从页面的文件类型是否一致
      this.showCloseScreen = true
      this.showBitRelational = false // 切换分屏模式自动关闭位号基本信息面板
      this.$refs.fileView.playerSpan = 12
      this.spotHotEditVisible = false
      // 如果是ht
      if (fileType === 'wizdrawing') {
        const fileRes = await DocumentService.findFileUrl({
          id: data.md5,
        })
        if (fileRes) {
          this.splitFileUrl = fileRes // 分屏的文件路径
          // 根据当前选中屏幕区分切换文档的屏幕
          if (this.$refs.fileView.focusScreen === 'left') {
            this.$refs.fileView.splitScreenFileName = data.fileName
            this.changeFile({
              resourceUrl: fileRes,
              fileType: `${fileType}`,
              versionTag: data.versionTag,
              documentId: data.documentId,
              fileId: data.fileId,
              flag: data.flag ? Number(data.flag) : data.flag,
            })
          } else {
            this.changeMainFile({
              mainFileType: `${fileType}`,
              fileName: data.fileName,
              mainResourceUrl: fileRes,
              mainVersionTag: data.versionTag,
              documentId: data.documentId,
              fileId: data.fileId,
              flag: data.flag ? Number(data.flag) : data.flag,
            })
          }
          return
        }
      }
      // 如果不是pr文件就预览展示
      // if (fileType !== 'pr') {
      // const resourceUrl = `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${data.md5}`
      const kkfileView = `${data.fileId}.${fileType}`
      const resourceUrl = this.getPreviewUrl(kkfileView, this.currentModel.classId, data.documentId)
      console.log(resourceUrl, 'resourceUrl')
      if (this.$refs.fileView.focusScreen === 'left') {
        this.splitFileUrl = resourceUrl // 分屏的文件路径
        this.$refs.fileView.splitScreenFileName = data.fileName
        this.changeFile({
          resourceUrl,
          fileType: `${fileType}`,
          versionTag: data.versionTag,
          documentId: data.documentId,
          fileId: data.fileId,
          flag: data.flag,
        })
      } else {
        this.changeMainFile({
          mainFileType: `${fileType}`,
          fileName: data.fileName,
          mainResourceUrl: resourceUrl,
          mainVersionTag: data.versionTag,
          documentId: data.documentId,
          fileId: data.fileId,
          flag: data.flag,
        })
      }
      //   return
      // }
      console.log(this.$refs.fileView.focusScreen, 'this.$refs.fileView.focusScreen')
      // if (this.$refs.fileView.focusScreen === 'left') {
      //   // 分屏模型文件
      //   this.$refs.fileView.splitScreenPlayerId = data.md5
      //   this.$refs.fileView.fileType = 'pr'
      //   this.$refs.fileView.splitFilePrId = data.fileId
      //   this.splitFilePrId = data.md5
      //   this.$refs.fileView.code = this.currentCode
      // } else {
      //   this.changePlayerId(data.md5)
      // }
    },
    // 切换分屏
    switchScreen() {
      if (this.$refs.fileView.focusScreen === 'left') {
        this.$refs.fileView.playerSpan = this.showCloseScreen ? 24 : 12
      } else {
        this.$refs.fileView.playerSpan = this.showCloseScreen ? 0 : 12
      }
      this.showCloseScreen = !this.showCloseScreen
    },
    // 关闭分屏
    closeSplitScreen() {
      this.$refs.fileView.focusScreen = 'left'
      this.$refs.fileView.playerSpan = 24
      this.splitFileUrl = ''
      this.splitFilePrId = ''
    },
    changePlayerId($onData) {
      // this.$refs.fileView.fileType = '.pr'
      this.$refs.fileView.mainFileType = 'pr'
      this.$refs.bitRelational.mainFileType = 'pr'
      this.$nextTick(() => {
        this.defaultUrlPrams = {
          documentId: $onData.id,
          fileId: $onData.defaultFileId,
        }
        this.currentPlayerId = $onData.md5
        this.$refs.fileView.playerId = $onData.md5
        this.$refs.fileView.mainScreenFileName = $onData.fileName
        // 切换模型时记录文件id，切换模块时不用重新加载
        this.modelDocumentId = $onData.id || this.modelDocumentId
        if (this.$route.query.fenceWarning) {
          this.showComponents = 'personnelPositioning'
          this.showDialog = true
        }
      })
    },
    changeTagCode(code, tagId, findType, identifier) {
      if (this.$refs.fileView.mainFileType === 'pr' || this.$refs.fileView.fileType === 'pr') {
        this.$nextTick(() => {
          this.$refs.fileView.code = code
        })
        // if (this.$refs.fileView.mainFileType === 'svg') {
        //   // 分屏是pr主屏是svg，居中svg
        //   window.postMessage(
        //     {
        //       code,
        //       type: 'modelTrigger',
        //       centerModel: false,
        //     },
        //     '*'
        //   )
        // }
      } else if (
        this.$refs.fileView.mainFileType === 'wizdrawing' ||
        this.$refs.fileView.fileType === 'wizdrawing'
      ) {
        this.$refs.fileView.setHtCodeCenter({
          type: 'modelTrigger',
          code,
        })
      } else if (
        this.$refs.fileView.mainFileType === 'svg' ||
        this.$refs.fileView.fileType === 'svg'
      ) {
        // 多加一个别名标识identifier传入进行定位标签
        window.svgData[window.location.href].svgHotTrigger(code, tagId, findType, identifier)
      }
    },
    changeFile($onData) {
      // 点击文件实现列表改变
      this.$refs.fileView.fileVersionTag = ''
      this.$refs.fileView.fileType = $onData.fileType
      this.$refs.fileView.fileId = $onData.fileId
      this.$refs.fileView.drawUrl = $onData.resourceUrl
      this.$refs.fileView.fileVersionTag = _.isNil($onData.versionTag) ? 0 : $onData.versionTag
      this.$refs.fileView.fileDocumentId = $onData.documentId
      this.$refs.fileView.fileFlag = $onData.flag
    },
    changeMainFile($onData) {
      this.$nextTick(() => {
        this.$refs.fileView.mainVersionTag = ''
        this.$refs.fileView.mainFileType = $onData.mainFileType
        // this.$refs.bitRelational.mainFileType = 'pr'
        this.$refs.fileView.mainResourceUrl = $onData.mainResourceUrl
        this.$refs.fileView.mainScreenFileName = $onData.fileName
        this.$refs.fileView.mainVersionTag = _.isNil($onData.versionTag) ? 0 : $onData.versionTag
        this.$refs.fileView.mainDocumentId = $onData.documentId
        this.$refs.fileView.mainFileId = $onData.fileId
        this.$refs.fileView.mainFlag = $onData.flag
        this.isCanAddHot = $onData.flag === 2
        this.mainFileType = $onData.mainFileType
      })
    },
    changeCurrentSelectedFileId(val) {
      this.currentSelectedFileId = val
    },
    async getModelData($onData) {
      console.log($onData, 'ondata-11')
      if ($onData.data.classId) this.currentModel = $onData.data
      this.currentModelItem = $onData.data ? $onData.data.item : 0
      if ($onData.data.code === '' && $onData.data.visible === 1 && $onData.data.name) {
        $onData.data.code = $onData.data.name
      }
      if ($onData.data && ($onData.data.tagId || $onData.data.code)) {
        // 宝昌项目关联设备code，设置测点
        this.tagId = $onData.data.tagId
        window.tagId = $onData.data.tagId
        // 宝昌点击模型获取范围内视频监控设备
        if (this.showComponents === 'monitorList' || this.showComponents === 'bindMeasurePoint') {
          this.$refs.componentsRef.clickModel($onData.data.code)
        }
        let code
        let fileId = this.currentSelectedFileId
        // 点击模型上时
        if ($onData.type === 1 || $onData.type === 3) {
          code = `${$onData.data.code}`
          fileId = $onData.data.fileId || this.currentSelectedFileId
        } else {
          // 点击左边关联位号树结构时触发
          code = `${$onData.data.code}`
          // code = `${$onData.data.nameSpace}${$onData.data.code}`
          //   ? `${$onData.data.nameSpace}${$onData.data.code}`
          //   : `${this.currentSelectedFileId}${$onData.data.code}`
          // 目的是操作云渲染的相机移动到相应的位置
          this.defaultSvgCode = code
        }
        this.currentCode = code
        // 如果svg的code存在，就用svg的code查对应的tagId
        if (code && this.lastCode !== code) {
          this.lastCode = code
          // const res = await TagService.getDynamicTableResult({
          //   standardId: this.standardId,
          //   skipCount: 1,
          //   maxResultCount: 999,
          //   sorting: '',
          //   cateCode: 'Tag',
          //   filter: code,
          // })
          const res = await TagService.getDynamicTableById({
            standardId: this.standardId,
            cateCode: 'Tag',
            code,
          })
          if (res && res.code === 0 && !_.isEmpty(res.data)) {
            // this.tagId = res.data[0].id
            this.tagId = res.data.id
          }
        }
        // 设置右侧弹框的内容
        // const res = await DocumentService.findTagByFile({
        //   site_id: this.currentProject.id,
        //   code,
        //   file_id: fileId,
        // })
        this.numTreeData()
        this.documentTreeData()
        this.getDynamicTableHeaders(code, $onData)
      }
    },
    // 动态获取表头
    async getDynamicTableHeaders(code, $onData) {
      if (!this.tagId) return
      const res = await TagService.getDynamicTableHeaders({
        standardId: this.standardId,
        code: 'Tag',
      })
      if (res && res.code === 0 && res.data) {
        this.tableHeader = res.data
        this.getDynamicTableById(code, $onData)
      } else {
        this.tableHeader = []
      }
    },
    async getDynamicTableById(code, $onData) {
      if (!this.tagId) return
      const res = await TagService.getDynamicTableById({
        standardId: this.standardId,
        cateCode: 'Tag',
        dataId: this.tagId,
      })
      if (res && res.code === 0 && res.data) {
        this.currentModel = {
          id: res.data.id,
          classId: res.data.class_id,
        }
        Object.keys(res.data).forEach((key) => {
          _.map(this.tableHeader, (item) => {
            if (key === `${item.tableName}.${item.columnName}`) {
              item.value = res.data[key]
            }
            return item
          })
        })
        let tagCode = null
        _.map(this.tableHeader, (item) => {
          if (item.columnName.toLowerCase() === 'code') {
            tagCode = item.value
          }
        })
        if (this.$refs.bitRelational) {
          this.$refs.bitRelational.bitBasicAttrData = this.tableHeader
          if ($onData.type === 3) {
            // svg单点测点
            this.currentFileCode = tagCode
          }
          if ($onData.type === 2) {
            // 解决点击左侧，左侧树是位号编码， svg图纸中是标示名，不能定位的问题
            this.changeTagCode(code, this.tagId, $onData.data.findType, $onData.data.identifier)
          }
          window.tagId = tagCode // 解决第一次打开svg图纸默认定位时，图纸里面的测点是标识名而不是实际的位号编码问题
        }
      } else if (this.getSvgCodeDataFlag && $onData.type === 3) {
        this.getModelData({ data: { code: $onData.data.reverseCode }, type: 3 })
        this.getSvgCodeDataFlag = false
      } else if (this.$refs.bitRelational) {
        this.$refs.bitRelational.templateAttrSetList = []
        this.$refs.bitRelational.generalAttribute = []
        this.$refs.bitRelational.treeData = []
        this.$refs.bitRelational.treeFile = []
        // 拿到返回值赋值给基本属性表单
        this.$refs.bitRelational.bitBasicAttrForm = {
          nameSpace: '',
          code: '',
          name: '',
          shortDescription: '',
          longDescription: '',
          tagclassname: '',
        }
      }
    },
    // 获取关联位号树的数据
    async numTreeData() {
      if (this.tagId) {
        const res = await this.apiTags({
          method: 'docRelationTag',
          params: {
            id: this.tagId,
            standardId: this.standardId,
          },
        })
        if (res && res.data && res.code === 0) {
          this.$refs.bitRelational.treeDatas = res.data
        }
      }
    },
    // 获取关联文档树的数据
    async documentTreeData() {
      if (this.tagId) {
        const res = await this.apiTags({
          method: 'docRelationFile',
          params: {
            id: this.tagId,
            standardId: this.standardId,
          },
        })
        if (res && res.data && res.code === 0) {
          this.$refs.bitRelational.treeFiles = res.data
        }
      }
    },
    changeFileLocation(location) {
      this.$refs.fileView.fileLocationByComponent = `page=${location.page}&zoom=auto`
    },
    /**
     * @description: 展示标记
     * @param {*} node 标记信息
     * @return {*}
     */
    showMarker(node) {
      this.$refs.fileView.showMainEditPhoto = true
      this.$refs.fileView.MainEditViewProps = {
        imgUrl: this.currentEnv.VUE_APP_PLANT_SERVER + node.screenshotUrl,
        showMark: true,
        name: node.name,
        remark: node.remark,
        position: node.cameraPosition,
      }
    },
    handleAnnotationClose() {
      // Close the annotation component
      this.showImageAnnotation = false
    },
    // 监听message
    async watchMessage(e) {
      console.log(e, '监听message')
      if (e.data.type === 'svgCapture') {
        this.captureProps.imgUrl = e.data.imgBase
        if (!this.showImageAnnotation) {
          this.print(this.captureProps.imgUrl)
        }
      }
      const self = this
      // if (
      //   self.$refs &&
      //   self.$refs.fileView &&
      //   self.$refs.fileView.mainScreenFileName.split('.')[0] !== self.$route.query.title
      // )
      //   return
      // 针对svg专门处理
      if (self.$refs && self.$refs.fileView && self.$refs.fileView.mainFileType === 'svg') {
        // 获取svg测点集合
        const iframeDocument = document
          .getElementsByTagName('iframe')[0]
          .contentDocument.getElementsByTagName('iframe')[0].contentDocument
        const svgDom = iframeDocument.getElementsByTagName('svg')[0]
        // 移除光标
        this.removeMarker(svgDom)
        this.isAddActiveVisible = false
      }
      this.svgParams = e.data
      // 监听svg触发
      if (
        e.data.type === 'svgTrigger' &&
        this.currentFileCode !== e.data.code &&
        !this.isAddTag &&
        !this.isEditTag
      ) {
        // 【非编辑和新增状态】
        this.currentFileCode = e.data.code
        // 点击svg上测点
        if (self.$refs.fileView.mainFileType === 'pr' || self.$refs.fileView.fileType === 'pr') {
          // 如果是云渲染模型就移动相机渲染模型，然后切换右侧的基本信息
          // self.changeTagCode.call(self, '1380J0PAC10AP001') // zh测试数据，正式：e.data.textCode
          self.changeTagCode.call(self, e.data.code) // zh测试数据，正式：e.data.textCode
          return
        }
        this.getSvgCodeDataFlag = true
        // 如果是svg就直接替换右侧的基本信息
        self.getModelData.call(self, {
          data: e.data,
          type: 3, // 如果是svg单点触发
        })
        if (this.showDocRelational) {
          this.$refs.docRelational.targetId = e.data.tagId
          console.log(this.$refs.docRelational, 'docRelational')
        }
        // 监听ht触发
      } else if (e.data.type === 'svgTrigger' && this.isEditTag) {
        // 【编辑热点】
        // 分屏时不允许编辑
        if (
          this.$refs.fileView?.playerSpan &&
          this.$refs.fileView.playerSpan !== 24 &&
          this.$refs.fileView.playerSpan !== 0
        ) {
          return
        }
        if (!e.data.isHotSpot) {
          this.$message.error('当前点击位置的位号非热点，请新增')
          return
        }
        // 只有未移交的才允许编辑
        // const flag =
        //   this.$refs.fileView.focusScreen === 'left'
        //     ? this.$refs.fileView.mainFlag
        //     : this.$refs.fileView.fileFlag
        // if (!_.isNumber(flag)) {
        //   this.$message.warning('未获取到文档移交状态！')
        //   return
        // }
        // if (flag !== 2) {
        //   const flagStatus = flag === 0 ? '已移交' : '审核中'
        //   this.$message.warning(`当前文件${flagStatus}，不允许编辑！`)
        //   return
        // }
        let point = ''
        const attrs = e.data.textAttributes
        if (attrs.transform) {
          point = attrs.transform
        } else if (attrs.x && attrs.y) {
          point = `x="${attrs.x}",y="${attrs.y}"`
        }
        if (!point) {
          // this.$message.warning('svg热点坐标获取失败!')
          return
        }
        this.spotHotEditVisible = true
        const isRepeat = _.find(this.svgTableData, (item) => {
          return item.originContent === e.data.code
        })
        if (isRepeat) {
          return
        }
        this.svgTableData.push({
          originContent: e.data.code,
          newContent: e.data.code,
          point,
        })
        // this.svgParams = e.data
      } else if (
        _.isString(e.data) &&
        e.data.indexOf('tagClick') > -1 &&
        !this.isAddTag &&
        !this.isEditTag
      ) {
        if (this.$refs.fileView.setFocusScreen) {
          this.$refs.fileView.setFocusScreen(e.source.currentScreen)
        }
        const params = JSON.parse(e.data)
        if (params.data && params.data.code) {
          if (self.$refs.fileView.mainFileType === 'pr' || self.$refs.fileView.fileType === 'pr') {
            // 如果是云渲染模型就移动相机渲染模型，然后切换右侧的基本信息
            self.changeTagCode.call(self, params.data.code)
            return
          }
          // 如果是svg就直接替换右侧的基本信息
          self.getModelData.call(self, {
            data: params.data,
            type: 1,
          })
        }
      } else if (['svgTrigger', 'svgBGTrigger'].includes(e.data.type) && this.isAddTag) {
        // 【新增热点】
        // 已移交的文档不允许添加标签
        // if (this.isCanAddHot && this.$refs.fileView.showHotSaveIcon) {
        this.activeObj = {}
        this.activeObj.top = e.data.y
        this.activeObj.left = e.data.x
        this.activeObj.realLocation = e.data.realLocation
        this.activeObj.code = ''
        if (e.data.textAttributes) {
          this.$set(this.activeObj, 'fontSizeVal', e.data.textAttributes['font-size'] || '1')
        } else {
          this.$set(this.activeObj, 'fontSizeVal', '1')
        }
        this.temporaryVal = ''
        this.isAddActiveVisible = true
        this.getActitiveObjTableData()
        // 插入光标
        const iframeDocumentNew = document
          .getElementsByTagName('iframe')[0]
          .contentDocument.getElementsByTagName('iframe')[0].contentDocument
        const svgDomNew = iframeDocumentNew.getElementsByTagName('svg')[0]
        this.insertMarker(svgDomNew)
      } else if (e.data.type === 'temporarySvgTrigger' && this.isAddTag) {
        // 【新增时编辑临时热点（还没保存的）】
        // console.log(e.data, '修改临时热点')
        // console.log(this.svgHotTagInfos, 'svgHotTagInfos')
        this.activeObj = this.svgHotTagInfos.find((item) => {
          return item.id === e.data.temporaryVal
        })
        this.$set(this.activeObj, 'fontSizeVal', this.activeObj.fontSize)
        this.activeObj.realLocation = e.data.realLocation
        this.activeObj.code = e.data.code
        this.temporaryVal = e.data.temporaryVal
        this.isAddActiveVisible = true
        await this.getActitiveObjTableData()
        this.setDefaultSelection()
      } else if (e.data.type === 'notFound' && !this.isEditTag && !this.isAddTag) {
        this.$message.warning('图中未找到该位号！')
      }
    },
    // 设置表格默认勾选
    setDefaultSelection() {
      const selectedRow = this.activeObjTableData.find((row) => {
        return row.id === this.activeObj.tagId
      })
      selectedRow.showSurface = this.activeObj.showSurface
      if (selectedRow) {
        this.$nextTick(() => {
          this.$refs.activeObjMultipleTable.toggleRowSelection(selectedRow, true)
        })
      }
    },
    // 返回
    closeDocument() {
      window.history.go(-1)
    },
    // 获取预览URL
    getPreviewUrl(kkfile, classId, documentId) {
      const fileNameType = _.last(_.split(kkfile, '.')) // 文件格式
      console.log(fileNameType, 'fileNameType-111')
      const filePreviewServerUrl = `${this.filePreviewServer}/#/file-preview`
      let url = `url=${this.standardServer}/api/std/file/kkfileview/${kkfile}` // 大部分文件格式通用
      if (['dxf', 'dwg', 'svg'].includes(fileNameType)) {
        url = `url=${this.standardServer}/api/std/file/${kkfile.split('.')[0]}`
        console.log(url, 'url-222')
      }
      const type = `type=${fileNameType}&name=resource.${fileNameType}`
      let previewUrl = `${filePreviewServerUrl}?${url}&${type}`

      // pr预览url
      if (fileNameType === 'pr') {
        const prQuery = {
          documentId: documentId || this.$route.query.documentId,
          title: '',
          standardId: this.standardId,
          classId,
          isVersion: '0', // 是否是历史版本查看
          token: localStorage.getItem('authorization'),
          ShowClassicLeft: false,
          ShowClassicTop: false,
        }
        previewUrl = `${this.basePath}/fullscreen/model-doc-view/index?${qs.stringify(prQuery)}`
      }

      return previewUrl
    },
    // 初始化文件预览
    initFilePreview(version) {
      const fileInfo = this.compareData[version]
      if (!fileInfo.kkfile_view) {
        this.$message.error('文件不存在')
        return
      }
      if (!fileInfo.kkfile_view.includes('.')) {
        this.$message.error('文件格式不正确')
        return
      }
      const fileType = _.last(_.split(fileInfo.kkfile_view, '.'))
      const previewUrl = this.getPreviewUrl(fileInfo.kkfile_view, fileInfo.class_id)
      if (version === 'version1') {
        this.fileType1 = fileType
        this.svgUrl1 = previewUrl
        this.prUrl1 = previewUrl
      } else {
        this.fileType2 = fileType
        this.svgUrl2 = previewUrl
        this.prUrl2 = previewUrl
      }

      window.wujie.setupApp({
        name: version, // 启动kkfileview微服务的名称
        url: `${previewUrl}`, // 文件地址
        el: `#${version}`, // 文件挂载的dom元素
      })
      window.wujie.startApp({ name: version })
    },
    // 切换全屏
    toggleFullScreen(version) {
      // 获取对应版本的预览URL
      const fileInfo = this.compareData[version]
      if (!fileInfo?.kkfile_view) {
        this.$message.warning('无法获取文件信息')
        return
      }

      try {
        const previewUrl = this.getPreviewUrl(fileInfo.kkfile_view, fileInfo.class_id)
        // 在新标签页打开
        window.open(previewUrl, '_blank')
      } catch (error) {
        console.error('打开预览失败:', error)
        this.$message.error('打开预览失败')
      }
    },
    print(imgUrl) {
      let printContent = `
        <html>
        <head>
          <title>${this.defaultUrlPrams.title}-打印</title>
          <style>

            body {
              margin: 0;
              padding: 20px;
              background-color: white;
              font-family: Arial, sans-serif;
            }
            .print-page {
              margin: 0 auto 40px;
              padding: 10px;
              text-align: center;
              page-break-after: always;
            }
            .print-page:last-child {
              page-break-after: avoid;
            }
            img {
              max-width: 100%;
              height: auto;
              display: block;
              margin: 0 auto;
            }
            table {
              border-collapse: collapse;
              width: 100%;
              margin: 20px 0;
            }
            th, td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
            }
            th {
              background-color: #f2f2f2;
            }
            @media print {
              body {
                padding: 0;
              }
              .print-page {
                padding: 0;
                margin-bottom: 0;
              }
            }
          
</style>
        </head>
        <body>
      `
      const imgClone = document.createElement('img')
      imgClone.src = imgUrl
      imgClone.style.maxWidth = '100%'
      imgClone.style.height = 'auto'

      // 创建页面容器
      printContent += `
        <div class="print-page">
          ${imgClone.outerHTML}
        </div></body></html>
      `
      // 创建打印窗口
      const printWindow = window.open('', '_blank')
      if (!printWindow) {
        ElMessage.error('无法打开打印窗口，请检查浏览器设置')
        return
      }

      // 写入打印内容并打印
      printWindow.document.write(printContent)
      printWindow.document.close()

      // 等待页面加载完成后执行打印
      printWindow.onload = () => {
        printWindow.print()
        // 打印对话框关闭后关闭打印窗口
        printWindow.onafterprint = () => {
          printWindow.close()
        }
      }
    },
    // 处理标注
    handleAnnotation(type) {
      window.svgData[window.location.href].svgCapture()
      if (type === 'print') {
        return
      }
      this.showImageAnnotation = true
    },
  },
  created() {
    this.currentWindow = window
    // 判断当前项目
    if (this.currentEnv.VUE_APP_CURRENT_PROJECT === 'BC') {
      this.setSemitransparent = true
    }
    this.modelDocumentId = this.$route.query.documentId || ''
    this.defaultUrlPrams = _.assign(this.defaultUrlPrams, this.$route.query)
    // 从电缆、进度、碰撞点击进来
    if (this.defaultUrlPrams.showCheck) {
      this.changeMode(this.defaultUrlPrams.type, [this.defaultUrlPrams.showCheck])
    }
    localStorage.setItem('routeQuery-docView', JSON.stringify(this.$route.query))
    /**
     * 从位号浏览点击进来
     */
    // 当文件不为pr文件时
    this.currentSelectedFileId = this.defaultUrlPrams.changeCurrentSelectedFileId
      ? this.defaultUrlPrams.changeCurrentSelectedFileId
      : ''
    if (this.defaultUrlPrams.isPr === 0) {
      this.changeMainFile(this.defaultUrlPrams)
    }
    if (this.defaultUrlPrams.isPr === 1) {
      this.changePlayerId(this.defaultUrlPrams)
    }
    /**
     * 工作台点击进来，查看标记
     */
    const defaultParams = this.$route.params
    if (defaultParams.type === 'showMark') {
      // 切换标记状态为显示， 模型与文档定位
      this.showAndLocationMark(defaultParams)
    }
  },
  mounted() {
    // setSvgDialogDrag(this.$refs.svgEditDialog)
    window.addEventListener('message', this.watchMessage, false)
    // 版本比较
    if (this.pageType === 'compareVersions') {
      this.initFilePreview('version1')
      this.initFilePreview('version2')
    }
  },
  activated() {
    window.tagId = null
    const node = document.getElementById('EngineVideo')
    if (node) {
      node.play()
    }
    if (this.$refs.fileView && this.$refs.fileView.mainFileType === 'wizdrawing') {
      this.$refs.fileView.htLoad(this.$refs.fileView.mainResourceUrl, 'left')
    }
    if (this.$refs.fileView && this.$refs.fileView.fileType === 'wizdrawing') {
      this.$refs.fileView.htLoad(this.$refs.fileView.drawUrl, 'right')
    }
  },
  beforeDestroy() {
    window.tagId = null
  },
  deactivated() {
    window.tagId = null
    window.removeEventListener('message', this.watchMessage)
  },
}
</script>

<style scoped lang="scss">

@import './css/semitransparent.scss';
.modal--svg {
  top: 40px;
  left: 0;
  right: 0;
  bottom: 0;
}
.height-half {
  height: 50%;
}
.iconfont {
  z-index: 999;
}
.icon-right {
  top: 70px;
  left: 0px;
  background-color: #eee;
  padding: 0px 8px;
  z-index: 9999999;
}
.icon-left {
  top: 70px;
  right: 0px;
  background-color: #eee;
  padding: 0px 8px;
  z-index: 9999999;
}
.icon-collapase-site {
  top: 86px;
  left: 390px;
  // transform: rotate(90deg);
  width: 20px;
  height: 20px;
  line-height: 15px;
  text-align: center;
  z-index: 3000;
  border-radius: 50%;
  font-weight: bold;
}

.icon-expand-site {
  top: 80px;
  // transform: rotate(-90deg);
  z-index: 3000;
  width: 30px;
  height: 30px;
  line-height: 15px;
  text-align: center;
  border-radius: 0px 0px 5px 5px;
  div {
    border-radius: 50%;
  }
}
.icon-expand-site-basic {
  top: 80px;
  right: 5px;
  // transform: rotate(90deg);
  z-index: 2999;
  width: 30px;
  height: 30px;
  line-height: 15px;
  text-align: center;
  border-radius: 0px 0px 5px 5px;
  div {
    border-radius: 50%;
  }
}
.icon-collapase-site-basic {
  top: 85px;
  right: 26px;
  left: auto;
  // transform: rotate(-90deg);
  z-index: 2999;
  span {
    right: -2px;
  }
}

.split-icon {
  top: 5px;
  right: 5px;
  background-color: #eee;
  padding: 3px 8px;
  border-radius: 5px 0px 0px 5px;
  z-index: 9999999;
  &.icon-collapase {
    border-radius: 0px 5px 5px 0px;
  }
}
.preview-svg {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // background: #000;
  z-index: 999;
}
.preview-calc {
  height: calc(100%-40px);
}
.z-index-100 {
  z-index: 100 !important;
}
.z-index-998 {
  z-index: 998 !important;
}
.edit-style {
  color: #1890ff;
  &:focus-visible {
    border: 1px solid #dcdee2;
    border-radius: 4px;
    padding: 0 5px;
    outline: none;
  }
}
.activeObj-box {
  position: absolute;
  display: flex;
  top: 200px;
  left: 100px;
  z-index: 999;
  background: cornsilk;
  border-radius: 6px;
  .el-select {
    width: 100px;
  }
}
.noSelect {
  /deep/table {
    tbody {
      tr {
        td {
          &:first-child {
            color: #444 !important;
            user-select: none !important;
          }
        }
      }
    }
  }
}
.position-absolute {
  position: absolute;
}
.position-relative {
  position: relative;
}
.border-color-blue {
  border: 1px solid #4aa0ff !important;
}
.b {
  font-weight: bold;
}
.main-color {
  color: var(--tagPrimaryText);
}
.can-not-input {
  ::v-deep input {
    pointer-events: none;
  }
}
.file-header {
  width: calc(100% - 10px);
  padding: 10px;
  margin-left: 5px;
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  background: #f5f7fa;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}
.z-index-999 {
  z-index: 999 !important;
}
.annotation-list-panel {
  position: absolute;
  top: 0;
  right: 0;
  width: 400px;
  height: 100%;
  background: #fff;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  flex-direction: column;

  .annotation-list-header {
    height: 50px;
    padding: 0 20px;
    border-bottom: 1px solid #ebeef5;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: 16px;
      font-weight: 500;
      color: #303133;
    }

    .close-icon {
      font-size: 20px;
      color: #909399;
      cursor: pointer;

      &:hover {
        color: #409eff;
      }
    }
  }

  .annotation-list {
    flex: 1;
    overflow-y: auto;
    padding: 20px;

    .annotation-items {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .annotation-item {
      border: 1px solid #ebeef5;
      border-radius: 4px;
      padding: 15px;
      background: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .annotation-header {
        margin-bottom: 10px;

        .annotation-title {
          font-size: 14px;
          font-weight: 500;
          color: #303133;
        }
      }

      .annotation-content {
        display: flex;
        justify-content: center;

        .annotation-image {
          width: 100%;
          max-height: 300px;
          object-fit: contain;
        }

        .image-loading,
        .image-error {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 200px;
          background-color: #f5f7fa;
          color: #909399;

          i {
            font-size: 28px;
            margin-bottom: 8px;
          }

          p {
            margin: 0;
            font-size: 14px;
          }
        }

        .image-error {
          cursor: default;
          &:hover {
            color: #409eff;
          }
        }
      }
    }
  }
}
.annotation-content {
  position: relative;

  .delete-annotation-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 10;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 77, 79, 0.8);
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background-color: #ff4d4f;
      transform: scale(1.1);
    }

    i {
      color: #fff;
      font-size: 14px;
    }
  }
}

</style>
<style lang="scss">

.addActiveObj_Dialog {
  margin-top: 20vh !important;
}

</style>
